<template>
  <div class="pulldown-bswrapper"
      ref="bsWrapper">
      <div class="pulldown-scroller">
        <div class="pulldown-wrapper">
          <div class="tip-text">{{tipText}}</div>
          <p class="date-msg">最后更新:{{dataRefreshDate}}</p>
        </div>
        <slot></slot>
      </div>
  </div>
</template>
<script>
import BScroll from '@better-scroll/core'
import Pulldown from '@better-scroll/pull-down'

BScroll.use(Pulldown)
const TIME_BOUNCE = 800
// const REQUEST_TIME = 1000
const THRESHOLD = 70
const STOP = 56
// let STEP = 0
// pulldownRefresh state
const PHASE = {
  moving: {
    enter: 'enter',
    leave: 'leave'
  },
  fetching: 'fetching',
  succeed: 'succeed'
}
export default {
  name:'page-content-wrapper',
  props:['dataRefreshDate'],
  data() {
    return {
      tipText: '',
    }
  },
  watch:{
    dataRefreshDate(v){
      if(v){
        this.finishPullDown()
      }
    }
  },
  mounted(){
    this.initBscroll()
  },
  methods:{
    initBscroll(){
      this.bscroll = new BScroll(this.$refs.bsWrapper, {
        scrollY: true,
        click: true,
        tap:true,
        bounceTime: TIME_BOUNCE,
        useTransition: false,
        pullDownRefresh: {
          threshold: THRESHOLD,
          stop: STOP
        }
      })
      this.bscroll.on('pullingDown', this.pullingDownHandler)
      this.bscroll.on('enterThreshold', () => {
        this.setTipText(PHASE.moving.enter)
      })
      this.bscroll.on('leaveThreshold', () => {
        this.setTipText(PHASE.moving.leave)
      })
      this.bscroll.refresh()
    },
    async pullingDownHandler() {
      console.log('trigger pullDown')
      this.setTipText(PHASE.fetching)
      console.log('pullDownHandler--this=', this)
      try{
        await this.$parent.getData()
      }catch(error){
        console.log('oh, refreshData has error', error)
      }
      this.bscroll.finishPullDown()
      this.finishPullDown()
    },
    async finishPullDown() {
      setTimeout(() => {
        this.bscroll.refresh()
      }, TIME_BOUNCE + 100)
    },
    setTipText(phase = PHASE.default) {
      const TEXTS_MAP = {
        'enter': this.$parent.t('tuyere.down_refresh.contentdown'),//`下拉可以刷新`,
        'leave': this.$parent.t('tuyere.down_refresh.contentover'),//` 松开立即刷新`,
        'fetching': this.$parent.t('tuyere.down_refresh.contentrefresh'),//'正在刷新数据中...',
        'succeed': this.$parent.t('tuyere.down_refresh.contentsuccess'),//'刷新成功'
      }
      this.tipText = TEXTS_MAP[phase]
    },
    refreshScroll(){
      this.bscroll?.refresh()
    }
  }
}
</script>
<style lang="stylus" >
@import './style.styl'
</style>